import { FC } from 'react';
import useDeviceSize from '../../../../../hooks/useDeviceSize';
import { Alert, Divider, Flex, Spin, Text } from '../../../../../components/Element';
import { useCreateAccount } from './logic/useCreateAccount.logic';
import { accountSwitcherStyle } from '../AccountSwitcher/AccountSwitcher.style';
import { CreateAccountModal } from './subcomponents/CreateAccountModal';
import { BaseFormConfig, SignUpField, SubTypes } from '../../../Auth/logic/Auth.types';
import { useAppSelector } from '../../../../../hooks/ReduxHook';
type CreateAccountSelector = {
  refetch?: () => any;
};

export const CreateAccountSelector: FC<CreateAccountSelector> = ({ refetch }) => {
  const device = useDeviceSize();
  const style = accountSwitcherStyle(device);
  const { signUpConfigData, onSelectionClick, isLoading, error, hasSelectedType, getSelectedTypes, getSelectedFields } =
    useCreateAccount(refetch);
  const roles = useAppSelector((state) => state.auth.user?.roles);
  const needsSetup = Array.isArray(roles) && roles.length === 0;

  if (isLoading) return <Spin />;
  if (error && Object.keys(error || {})?.length)
    return <Alert showIcon={true} type="error" message="Error" description={error?.message} />;

  const SelectionBox = ({ title, subtitle, onClick }: { title: string; subtitle: string; onClick: Function }) => (
    <Flex style={style.selectionBoxJumbo} align="center" onClick={onClick}>
      <Flex vertical={true} gap={26} justify="start" align="start">
        <Text style={style.mainTag}>{title}</Text>
        <Text style={style.secondaryTag}>{subtitle}</Text>
      </Flex>
    </Flex>
  );

  return (
    <Flex vertical={true} gap={24}>
      {needsSetup && (
        <Alert
          showIcon={true}
          type="info"
          message="Finish setting up your account"
          description="Your account has no account type yet. Choose one and complete the form to continue."
        />
      )}
      {hasSelectedType ? (
        <CreateAccountModal refetch={refetch} fields={getSelectedFields} types={getSelectedTypes} />
      ) : (
        <>
          {signUpConfigData?.accountTypes?.map((item: BaseFormConfig) => (
            <SelectionBox
              title={`${item.key.replace('_', ' ')} Account`}
              subtitle={item.info}
              onClick={() => onSelectionClick(item)}
            />
          ))}
        </>
      )}
      <Divider style={style.solidDivider} />
    </Flex>
  );
};
